import { gql } from '@apollo/client';
import PostTitleWithIcons from '../../post/PostTitleWithIcons';
import POST_CONTENT_FRAGMENT from './PostContent';
import SERIES_SUMMARY_FIELDS_FRAGMENT from './SeriesSummaryFields';
import TOPIC_FIELDS_FRAGMENT from './TopicFields';
import USER_AVATAR_FRAGMENT from './UserAvatar';

const POST_FIELDS_FRAGMENT = gql`
  fragment PostFields on Post {
    id
    archivedAt
    publishedAt
    updatedAt
    views
    ...PostContent
    archiver {
      id
      name
    }
    contributors {
      id
      name
      ...UserAvatar
    }
    owner {
      id
      name
      ...UserAvatar
    }
    externalPost {
      id
      platform
      editUrl
      readUrl
      externalId
    }
    topics {
      ...TopicFields
    }
    series {
      ...SeriesSummaryFields
    }
    ...PostTitleWithIcons_post
  }
  ${POST_CONTENT_FRAGMENT}
  ${USER_AVATAR_FRAGMENT}
  ${TOPIC_FIELDS_FRAGMENT}
  ${SERIES_SUMMARY_FIELDS_FRAGMENT}
  ${
    // TODO: Fix this the next time the file is edited.
    // eslint-disable-next-line slab-graphql/no-unused-colocated-fragments
    PostTitleWithIcons.fragments.post
  }
`;

export default POST_FIELDS_FRAGMENT;
